export default function Error404() {
    return (
        <div>
            <h1>Error 404</h1>
            <p>
                We couldn't find that page.
            </p>
        </div>
    );
}